import api from "../utils/api";
import { errHandler } from "../utils/common";

export default class Wilayah {

  getAll = (source, opt = { searchBy: '', searchValue: '', page: 1, limit: 10, }) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/wilayah/${source}`, { params: opt })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  // Daftar region beserta provinsi anggotanya.
  getRegions = () => {
    return new Promise((resolve, reject) => {
      api
        .get("/api/regions")
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  // Region dari sebuah provinsi (resolusi Lab Tier 4).
  getProvinceRegion = (provinceId) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/province/${provinceId}/region`)
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  // Ganti seluruh daftar provinsi milik satu region.
  updateRegionProvinces = (id, provinceIds) => {
    return new Promise((resolve, reject) => {
      api
        .patch(`/api/regions/${id}/provinces`, { province_ids: provinceIds })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
}
